export default __webpack_public_path__ + "static/logo-stadtbibliothek-pad-black-bd5d1d4de1f0972f44348332f36d1195.jpg";